// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/date_time',['require','underscore','cleave','../question_form','sp/utilities/placeholder_supported','sp/utilities/restrict_numeric','sp/utilities/to_utc'],function(require) {
  var Cleave, DateTime, QuestionForm, _, placeholderSupported, restrictNumeric, toUTC;
  _ = require('underscore');
  Cleave = require('cleave');
  QuestionForm = require('../question_form');
  placeholderSupported = require('sp/utilities/placeholder_supported');
  restrictNumeric = require('sp/utilities/restrict_numeric');
  toUTC = require('sp/utilities/to_utc');
  return DateTime = (function(superClass) {
    extend(DateTime, superClass);

    function DateTime() {
      this.ampmChangeKeyupHandler = bind(this.ampmChangeKeyupHandler, this);
      this.minutesInputKeyupHandler = bind(this.minutesInputKeyupHandler, this);
      this.hoursInputKeyupHandler = bind(this.hoursInputKeyupHandler, this);
      this.dateInputKeyupHandler = bind(this.dateInputKeyupHandler, this);
      this.setCurrentTimeButtonClickHander = bind(this.setCurrentTimeButtonClickHander, this);
      return DateTime.__super__.constructor.apply(this, arguments);
    }

    DateTime.prototype.tagName = "ul";

    DateTime.prototype.className = "date-time-container";

    DateTime.prototype.events = {
      "click .set-current-time-button": "setCurrentTimeButtonClickHander"
    };

    DateTime.prototype.$triggerBtn = null;

    DateTime.prototype.$date = null;

    DateTime.prototype.$hours = null;

    DateTime.prototype.$minutes = null;

    DateTime.prototype.$ampm = null;

    DateTime.prototype.initialize = function(options) {
      this.values = [];
      if (!this.model.get('properties') || (this.model.get('properties').date == null) || (this.model.get('properties').time == null)) {
        this.model.get('properties').date = true;
      }
      return DateTime.__super__.initialize.call(this, options);
    };

    DateTime.prototype.render = function() {
      var $nowButton, date, nowButtonText, offset;
      DateTime.__super__.render.call(this);
      if (this.values.length) {
        date = new Date(this.values[0]);
        offset = date.getTimezoneOffset();
        date.setMinutes(date.getMinutes() + offset);
        this.values = [date];
      }
      if (this.model.get('properties').time && !this.model.get('properties').date) {
        this.renderTimeInput();
        nowButtonText = this.definitions.currentTime || "Set Current Time";
      } else if (this.model.get('properties').date && !this.model.get('properties').time) {
        this.renderDateInput().css({
          width: '100%',
          float: 'none'
        });
        nowButtonText = this.definitions.currentDate || "Set Current Date";
      } else {
        this.renderDateInput();
        this.renderTimeInput();
        nowButtonText = this.definitions.currentDatetime || "Set Current Date & Time";
      }
      $nowButton = $("<a>").text(nowButtonText).attr({
        href: "#",
        "class": 'set-current-time-button'
      });
      $('<li>').addClass('current-time').appendTo(this.el).append($nowButton);
      return this.el;
    };

    DateTime.prototype.renderDateInput = function() {
      var $li, cleaveDate, placeholderText;
      placeholderText = 'MM / DD / YYYY';
      $li = $('<li>').appendTo(this.el).addClass('date-inputs');
      this.$date = $("<input>").attr({
        "class": 'date-input',
        type: "text",
        placeholder: placeholderText,
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      }).prop('required', this.model.get('required') || false).appendTo($li).keyup(this.dateInputKeyupHandler);
      if (!placeholderSupported()) {
        $li.prepend($('<label>').text(placeholderText).addClass('date-label'));
      }
      cleaveDate = new Cleave(this.$date[0], {
        date: true,
        datePattern: ['m', 'd', 'Y']
      });
      return $li;
    };

    DateTime.prototype.renderTimeInput = function() {
      var $input, $li;
      $li = $('<li>').appendTo(this.el).addClass('time-inputs');
      if (!placeholderSupported()) {
        $li.append($('<label>').text('Hour : Minutes').addClass('time-label'));
      }
      this.$hours = $("<input>").attr({
        "class": "hours-input",
        type: "number",
        min: 1,
        max: 12,
        placeholder: 'Hour',
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      }).prop('required', this.model.get('required') || false).appendTo($li).keydown(restrictNumeric).keyup(this.hoursInputKeyupHandler);
      $li.append($('<div>').text(':').addClass('time-separator'));
      this.$minutes = $("<input>").attr({
        "class": "minutes-input",
        type: "number",
        min: 1,
        max: 59,
        placeholder: 'Minutes',
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      }).prop('required', this.model.get('required') || false).appendTo($li).keydown(restrictNumeric).keyup(this.minutesInputKeyupHandler);
      $input = $('<input>').attr({
        title: 'AM/PM',
        type: "checkbox",
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      }).change(this.ampmChangeKeyupHandler);
      this.$ampm = $('<label>').addClass("ampm-switch").append($input).append($('<div>').addClass("toggle-button")).appendTo($li);
      return $li;
    };

    DateTime.prototype.update = function() {
      var date, hour, val;
      date = new Date(0, 0, 0);
      if (this.$date && this.$date.length) {
        val = this.$date.val().split('/');
        date = new Date(val[2], val[0] - 1, val[1], 0, 0, 0);
      }
      if (this.$hours && this.$hours.length) {
        hour = Number(this.$hours.val());
        if (this.$ampm.find('input').prop('checked') && hour < 12) {
          date.setHours(hour + 12);
        } else {
          date.setHours(hour);
        }
      }
      if (this.$minutes && this.$minutes.length) {
        date.setMinutes(this.$minutes.val());
      }
      this.values[0] = toUTC(date);
      return this.trigger(QuestionForm.UPDATE_EVENT, this);
    };

    DateTime.prototype.setValues = function(vals) {
      var date, hours, minutes;
      if (_.isArray(vals) && vals[0] && vals[0].toString() !== 'Invalid Date') {
        date = new Date(vals[0]);
        if (this.model.get('properties').date && this.$date) {
          this.$date.val((date.getMonth() + 1) + " / " + date.getDate() + " / " + date.getFullYear());
        }
        if (this.model.get('properties').time) {
          if (this.$hours) {
            hours = date.getHours();
            this.$ampm.find('input').prop('checked', hours > 12);
            if (hours > 12) {
              hours = hours - 12;
            }
            this.$hours.val(hours);
          }
          if (this.$minutes) {
            minutes = date.getMinutes();
            if (minutes < 10) {
              minutes = "0" + minutes;
            }
            this.$minutes.val(minutes);
          }
        }
        return this.update();
      }
    };

    DateTime.prototype.setCurrentTimeButtonClickHander = function(e) {
      e.preventDefault();
      return this.setValues([new Date()]);
    };

    DateTime.prototype.dateInputKeyupHandler = function(e) {
      if (e.target.value) {
        return this.update();
      }
    };

    DateTime.prototype.hoursInputKeyupHandler = function(e) {
      if ($.isNumeric(e.target.value)) {
        if (e.target.value > 12) {
          e.target.value = 12;
        }
        return this.update();
      }
    };

    DateTime.prototype.minutesInputKeyupHandler = function(e) {
      if ($.isNumeric(e.target.value)) {
        if (e.target.value > 59) {
          e.target.value = 59;
        }
        if ($.isNumeric(this.$hours.val())) {
          return this.update();
        }
      }
    };

    DateTime.prototype.ampmChangeKeyupHandler = function(e) {
      if ($.isNumeric(this.$minutes.val()) && $.isNumeric(this.$hours.val())) {
        return this.update();
      }
    };

    return DateTime;

  })(QuestionForm);
});

